import { GetPlaceFromCoordinatesRequest } from '@eventbrite/geo-service-pysoa-model';

import { EMPTY_LOCATION } from '@/src/homepage/common';
import type { Location } from '@/src/homepage/types';
import { getPlaceFromCoordinates as getPlaceFromCoordinatesPysoaProxy } from '@/src/homepage/api/geo/getPlaceFromCoordinates';

/**
 * Get the place from coordinates via geo service (using api v3 or pysoa proxy).
 *
 * @param latitude the latitude of the location
 * @param longitude the longitude of the location
 */
export const getPlaceFromCoordinates = async (
    latitude: string | number,
    longitude: string | number,
    placeType?: GetPlaceFromCoordinatesRequest['body']['place_type'],
): Promise<Location> => {
    const emptyResponse = Promise.resolve(EMPTY_LOCATION);
    try {
        if (!latitude || !longitude) {
            return emptyResponse;
        }

        const place = await getPlaceFromCoordinatesPysoaProxy(latitude, longitude, placeType);

        if (place && Object.keys(place).length > 0) {
            // TODO: Handle localization
            const locale = 'default';
            const localizedHierarchy = place.localizations?.[locale];
            const { locality, region } = localizedHierarchy || {};

            return {
                currentPlace: locality?.full_name || null,
                currentPlaceParent: region?.full_name || null,
                latitude: place.latitude || null,
                longitude: place.longitude || null,
                placeId: place.id,
                placeType: place.place_type,
                slug: place.location_slug || null,
                isOnline: !place.id,
            };
        }
        return emptyResponse;
    } catch (e) {
        console.error('Failed to fetch location');
        console.error(e);
        return emptyResponse;
    }
};
